import { Action } from "redux";

import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Reviews load

export const STROLLER_ALL_REVIEWS_PHOTOS_FETCH_TRIGGER =
    "STROLLER_ALL_REVIEWS_PHOTOS_FETCH_TRIGGER";
export interface StrollerAllReviewsPhotosFetchTriggerAction {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_FETCH_TRIGGER;
    readonly strollerSlug: string;
}
export const STROLLER_ALL_REVIEWS_PHOTOS_FETCH_REQUEST =
    "STROLLER_ALL_REVIEWS_PHOTOS_FETCH_REQUEST";
export interface StrollerAllReviewsPhotosFetchRequestAction extends APIRequestAction {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_FETCH_REQUEST;
    readonly strollerSlug: string;
}
export interface StrollerAllReviewsPhotosFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        stroller: number;
        strollerReviews: number[];
    };
}
export const STROLLER_ALL_REVIEWS_PHOTOS_FETCH_SUCCESS =
    "STROLLER_ALL_REVIEWS_PHOTOS_FETCH_SUCCESS";
export interface StrollerAllReviewsPhotosFetchSuccessAction extends APISuccessAction<StrollerAllReviewsPhotosFetchNormalizedResponse> {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_FETCH_SUCCESS;
    readonly strollerSlug: string;
}
export const STROLLER_ALL_REVIEWS_PHOTOS_FETCH_FAILURE =
    "STROLLER_ALL_REVIEWS_PHOTOS_FETCH_FAILURE";
export interface StrollerAllReviewsPhotosFetchFailureAction extends APIFailureAction {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_FETCH_FAILURE;
    readonly strollerSlug: string;
}

export const strollerAllReviewsPhotosFetchTrigger = (
    strollerSlug: string,
): StrollerAllReviewsPhotosFetchTriggerAction => ({
    type: STROLLER_ALL_REVIEWS_PHOTOS_FETCH_TRIGGER,
    strollerSlug,
});
export const strollerAllReviewsPhotosFetchApi = {
    request: (strollerSlug: string): StrollerAllReviewsPhotosFetchRequestAction => ({
        type: STROLLER_ALL_REVIEWS_PHOTOS_FETCH_REQUEST,
        strollerSlug,
    }),
    success: (
        strollerSlug: string,
        response: StrollerAllReviewsPhotosFetchNormalizedResponse,
    ): StrollerAllReviewsPhotosFetchSuccessAction => ({
        type: STROLLER_ALL_REVIEWS_PHOTOS_FETCH_SUCCESS,
        strollerSlug,
        response,
    }),
    failure: (strollerSlug: string, error: string): StrollerAllReviewsPhotosFetchFailureAction => ({
        type: STROLLER_ALL_REVIEWS_PHOTOS_FETCH_FAILURE,
        strollerSlug,
        error,
    }),
};

///////////////////////////////////////////////////////////////////
// Show/Hide/Check thumbs

export const STROLLER_ALL_REVIEWS_PHOTOS_TOGGLE_THUMBS_TRIGGER =
    "STROLLER_ALL_REVIEWS_PHOTOS_TOGGLE_THUMBS_TRIGGER";

export interface StrollerAllReviewsPhotosToggleThumbsTriggerAction extends Action {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_TOGGLE_THUMBS_TRIGGER;
}

export const strollerAllReviewsPhotosToggleThumbsTrigger =
    (): StrollerAllReviewsPhotosToggleThumbsTriggerAction => ({
        type: STROLLER_ALL_REVIEWS_PHOTOS_TOGGLE_THUMBS_TRIGGER,
    });

export const STROLLER_ALL_REVIEWS_PHOTOS_CHECK_HIDE_THUMBS =
    "STROLLER_ALL_REVIEWS_PHOTOS_CHECK_HIDE_THUMBS";

export interface StrollerAllReviewsPhotosCheckHideThumbsAction extends Action {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_CHECK_HIDE_THUMBS;
}

export const strollerAllReviewsPhotosCheckHideThumbs =
    (): StrollerAllReviewsPhotosCheckHideThumbsAction => ({
        type: STROLLER_ALL_REVIEWS_PHOTOS_CHECK_HIDE_THUMBS,
    });
export const STROLLER_ALL_REVIEWS_PHOTOS_UPDATE_THUMBS =
    "STROLLER_ALL_REVIEWS_PHOTOS_UPDATE_THUMBS";

export interface StrollerAllReviewsPhotosUpdateThumbsAction extends Action {
    readonly type: typeof STROLLER_ALL_REVIEWS_PHOTOS_UPDATE_THUMBS;
    readonly hide: boolean;
}

export const strollerAllReviewsPhotosUpdateThumbs = (
    hide: boolean,
): StrollerAllReviewsPhotosUpdateThumbsAction => ({
    type: STROLLER_ALL_REVIEWS_PHOTOS_UPDATE_THUMBS,
    hide,
});
